module.exports = {
  "revenuestagechangesubmit": {
    "name": "revenuestagechangesubmit",
    "class": "usage",
    "properties": {
      "stageName": "string"
    },
    "namespace": "customer-data-properties",
    "version": "1"
  },
  "Pageview": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "screen": "string"
    },
    "namespace": "customer-data-properties",
    "version": "1"
  }
};